export default __webpack_public_path__ + "static/media/cancel.6254c370.svg";